import { Faction } from '../tree/faction';
import { Branch } from '../base/branch';
import { Node } from '../base/node';
import { Type } from './type';

export class Prototype extends Node  {
    static _type: string = 'Prototype';

    i_prototype: true = true;

    graphqlType?: string;
    meta?: string;
    data: any;

    constructor(source?: any) {
        super(source);

        if (source) {
            this.graphqlType = source.graphqlType;
            this.meta = source.meta;
            this.data = source.data;
        }
    }

    copy(source?: any) {
        super.copy(source);

        if (source) {
            this.graphqlType = source.graphqlType;
            this.meta = source.meta;
            this.data = source.data;
        }
    }

    get model(): any {
        const rest = super.model;
        if (rest.data) {
            const data: any = {};
            for (let key in rest.data) {
                const { type, ...value } = rest.data[key];
                if (type.data.interface?.length) {
                    value.interface = {
                        id: type.data.interface,
                        multiple: type.data.max != 1,
                    }
                }
                data[key] = value;
            }
            rest.data = data;
        }
        return rest;
    }

    override load(source?: any): void {
        this.copy(source);

        if (this.data) {
            for (let key in this.data) {
                const { type, ...value } = this.data[key];
                this.data[key] = { type: new Type(type), ...value };
            }
        }
    }

    override fit(branch: Branch): boolean {
        return branch instanceof Faction;
    }
}
